import RequireData from "hooks/RequireData";
import SageScreen from "kit/SageScreen";
import React from "react";
import { Dropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import teamSelector from "selectors/team";
import teamDetailIdSelector from "selectors/teamDetailId";
import teamStatusSelector from "selectors/teamStatus";
import AddMemberDialog from "./teamDetail/AddMemberDialog";
import TeamDetailInvitees from "./teamDetail/TeamDetailInvitees";
import TeamDetailMembers from "./teamDetail/TeamDetailMembers";
import styles from "./TeamDetail.module.scss";
import ChangeTeamNameDialog from "./teamDetail/ChangeTeamNameDialog";
import userSelector from "selectors/user";
import fetchUserStatusSelector from "selectors/fetchUserStatus";
import { fetchUser } from "actions/user";

const TeamDetail: React.FC = () => {
    const dispatch = useDispatch();
    const teamId = useSelector(teamDetailIdSelector);

    const [user] = RequireData(
        userSelector,
        fetchUserStatusSelector,
        fetchUser()
    );

    const [team, status] = RequireData(
        teamSelector(teamId || ""),
        teamStatusSelector(teamId || ""),
        {
            type: "com.sage.actions.team.IFetchTeam",
            teamId: teamId || "",
        } as sage.actions.team.IFetchTeam
    );

    const onRemoveFromTeam = React.useCallback(() => {
        dispatch({
            type: "com.sage.actions.team.IRemoveSelfFromTeam",
            teamId: teamId,
        } as sage.actions.team.IRemoveSelfFromTeam);
    }, [dispatch, teamId]);

    if (status === "error") {
        return <p>Error occurred. Please try again.</p>;
    }

    return (
        <>
            <AddMemberDialog teamId={teamId || ""} />
            <ChangeTeamNameDialog teamId={teamId || ""} />
            <SageScreen>
                <div className="row align-items-center">
                    <div className="col">
                        <h1>{team && team.name} </h1>
                        <Dropdown className={styles.actionDropdown}>
                            <Dropdown.Toggle variant="primary" size="sm">
                                Actions
                                <Dropdown.Menu>
                                    <Dropdown.Item
                                        data-toggle="modal"
                                        data-target="#addMemberModal"
                                    >
                                        Add Member
                                    </Dropdown.Item>
                                    {team && user && team.owner_id === user.id && (
                                        <Dropdown.Item
                                            data-toggle="modal"
                                            data-target="#changeTeamNameModal"
                                        >
                                            Change Team Name
                                        </Dropdown.Item>
                                    )}
                                    {team && user && team.owner_id !== user.id && (
                                        <>
                                            <Dropdown.Divider />
                                            <Dropdown.Item
                                                onClick={onRemoveFromTeam}
                                            >
                                                Leave Team
                                            </Dropdown.Item>
                                        </>
                                    )}
                                </Dropdown.Menu>
                            </Dropdown.Toggle>
                        </Dropdown>
                    </div>
                </div>
                <TeamDetailInvitees teamId={teamId} />
                <TeamDetailMembers team={team} teamId={teamId || ""} />
            </SageScreen>
        </>
    );
};

export default TeamDetail;
